//Views
PJQ.views.screenings = {};

PJQ.views.screenings.ScreeningDashboard = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Dashboard'),
		subTemplates: {
			faq: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Prequal-FAQ')
		},
		baseFaqItems: [
			{
				q: "Why am I being asked to complete this form?",
				a: "The requesting General Contractor, in an effort to improve their bidding process and ensure data consistency among their subcontractors have asked all subcontractors to keep on file updated company qualification data."
			},
			{
				q: "How often do I need to update this information?",
				a: "You have the ability to update your information at any time.  Only certain performance data will be required to updated annually as a majority of your company information may not change."
			},
			{
				q: "I've worked with the requesting General Contractor many times in the past, why am I being asked to complete this now?",
				a: "The requesting General Contractor is updating their database so that all subcontractors have current and consistent company and performance information on file regardless of previous contract awards."
			},
			{
				q: "What if I don’t know the answers to all the questions being asked?",
				a: "If you do not have the information on hand, you may return to the form once you are ready.  All of your previously entered information will remain intact."
			},
			{
				q: "I've completed every field but the form is not at 100%.",
				a: "Fields that are incomplete will be highlighted in red. Common fields that are overlooked as complete are phone number fields which require all 10 digits to be considered complete.  You can view the left hand menu to determine which section is incomplete."
			},
			{
				q: "One of our divisions/offices already filled in this information and it's all the same. Do I need to do it again?",
				a: "If you have received the request multiple times to your same email address, please contact the General Contractor as this means you have been entered twice in the address book of the General Contractor. If the requests have gone to different contacts within your company and each contact is responsible for submitting bids for their respective office/division, then yes each contact will need to fill out the form."
			}
		],
		proqualFaqItems: [
			{
				q: "I've already completed this form for another GC, can I transfer that info to this form?",
				a: "The information you fill out for the requesting General Contractor is for their eyes only.  However if you would like to share your current information and not have to fill out the full form for another party, please <a href='http://network.panteratools.com/pantera-network-faqpath/'>click here to find out how</a>."
			},
			{
				q: "I have never received a bid or job from this GC, why should I complete this form?",
				a: "In an effort to make better subcontracting decisions and provide subcontractors with the right opportunities, the data on this form will help us get you the requests that match your specialties with our upcoming work.  Filling out this form will increase the likelihood that you will be considered for a project in the future."
			},
			{
				q: "I only want to complete this form if I'm awarded a job.",
				a: "The requesting General Contractor is utilizing the this data in addition to information provided with bids. By taking the 15 minutes to complete this now will them know who is serious about bidding."
			}
		]
	},
	events: {
		'click .network-upgrade': 'networkUpgrade',
		'click .edit-profile': 'editProfile',
		'click .view-prequal-faq': 'viewFaq',
		'click .screening-back-to-dashboard': 'backToDashboard',
		'click .screening-dashboard-view-client': 'renderClientScreenings',
		'click .prequal-export-pdf-user': 'exportPDF',
		'click .prequal-export-excel-user': 'exportExcel'
	},
	afterRender: function () {
		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG)) {
			this.$('.network-upgrade,.edit-profile').removeClass('hidden');
		}

		if (!this.collection.hasItems()) {
			this.$('.screening-back-to-dashboard').addClass('hidden');

			let callback = _.bind(function (logoURL) {
				let publicClient = new PJQ.models.screenings.ScreeningClient({
					masterUserId: this.collection.options.masterUserId,
					logoURL: logoURL,
					prequal: new PJQ.models.prequal.Prequal({
						masterUserId: this.collection.options.masterUserId,
						contact: this.collection.options.contact
					})
				});
				this.renderClientPrequal(publicClient);
			}, this);
			if (this.collection.options.masterUserId === PJQ.constants.publicUserId) {
				callback(PJQ.constants.publicLogoURL);
			}
			else {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'users',
							value: this.collection.options.masterUserId
						},
						{
							endpoint: 'logo'
						}
					])
				}).get().done(function (response) {
					callback(response.url);
				});
			}
		}
		else {
			this.renderClients();
		}
	},
	renderNavClient: function (client) {
		if (client != null) {
			this.$('.screening-nav-client-info').html($('<img/>', {
				src: client.get('logoURL'),
				class: 'max-ht-75p max-wd-100'
			}));
			this.$('.screening-nav-client').animateCSS('slideDown');
		}
		else {
			this.$('.screening-nav-client').animateCSS('slideUp', function () {
				this.$('.screening-nav-client-info').empty();
			}, this);
		}
	},
	renderClients: function () {
		if (this.dashboardClients) {
			this.dashboardClients.render();
		}
		else {
			this.dashboardClients = new PJQ.views.screenings.ScreeningDashboardClients({
				el: this.$('.screening-dashboard-body'),
				collection: this.collection,
				dashboard: this
			});
		}
		this.$('.screening-dashboard-body').animateCSS('fadeIn');
	},
	renderClientScreenings: function (client, filter) {
		if (!(client instanceof PJQ.models.screenings.ScreeningClient)) {
			client = this.contextClient;
		}
		else {
			this.contextClient = client;
		}

		let percentComplete = client.prequal.get('percentComplete');
		if (percentComplete != null && percentComplete < 100 && client.get('isPrequalActive')) {
			this.renderClientPrequal(client);
		}
		else {
			this.checkPayment(client, _.bind(function () {
				this.checkTerms(client, _.bind(function () {
					if (this.headerAlert) {
						this.headerAlert.destroy();
						this.headerAlert = null;
					}

					this.$('.screening-back-to-dashboard,.screening-dashboard-nav-extend').animateCSS('slideDown');

					if (this.prequalEditor != null) {
						this.$('.screening-dashboard-view-client, .btn-export-prequal').animateCSS('slideUp');
						this.prequalEditor.remove();
						this.prequalEditor = null;
					}
					else if (this.dashboardClients != null) {
						this.dashboardClients.remove();
						this.dashboardClients = null;
					}

					this.loader = new PJQ.Loader(this.$('.screening-dashboard-body'));

					client.fetch({
						success: _.bind(function () {
							this.loader.remove();
							this.loader = null;
							this.screeningEditor = new PJQ.views.screenings.ScreeningClientEditor({
								el: this.$('.screening-dashboard-body'),
								model: client,
								filter: filter,
								navContainer: this.$('.screening-dashboard-nav-extend')
							});
						}, this)
					});

					this.renderNavClient(client);
				}, this));
			}, this))
		}
	},
	checkPayment: function (client, callback) {
		if (!client.get('isPaid')) {
			new PJQ.views.payment.PaymentModal({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'contacts',
						value: PJQ.app.session.contact.id
					},
					{
						endpoint: 'screenings',
						value: client.get('masterUserId')
					},
					{
						endpoint: 'payment'
					}
				]),
				onComplete: _.bind(callback, this),
				products: client.products
			});
		}
		else {
			callback();
		}
	},
	exportPDF: function () {
		this.export(false);
	},
	exportExcel: function () {
		this.export(true);
	},
	export: function (isExcel) {
		if (this.contextClient) {
			let prequal = this.contextClient.prequal,
				contactId = prequal.contact.get('contactId')
			PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: contactId
				},
				{
					endpoint: 'prequal'
				},
				{
					endpoint: 'export'
				}
			], [
				{
					parameter: 'masterUserId',
					value: this.contextClient.get('masterUserId') > 0 ? this.contextClient.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
				},
				{
					parameter: 'isExcel',
					value: isExcel
				}
			]));
		}
		else {
			PJQ.notifications.notify.errorNotify({
				message: 'Export failed.'
			});
		}
	},
	checkTerms: function (client, callback) {
		if (client.checkNeedsTerms()) {
			new PJQ.views.screenings.ScreeningTermsModal({
				collection: client.terms,
				onComplete: _.bind(callback, this)
			});
		}
		else {
			callback();
		}
	},
	renderClientPrequal: function (client) {
		if (!(client instanceof PJQ.models.screenings.ScreeningClient)) {
			client = this.contextClient;
		}
		else {
			this.contextClient = client;
		}

		if (client.checkNeedsTerms()) {
			new PJQ.views.screenings.ScreeningTermsModal({
				collection: client.terms,
				onComplete: _.bind(function () {
					this.renderClientPrequalUI(client);
				}, this)
			});
		}
		else {
			this.renderClientPrequalUI(client);
		}
	},
	renderClientPrequalUI: function (client) {
		this.renderNavClient(client);

		this.$('.screening-dashboard-body').animateCSS('fadeOut', function () {
			if (this.collection.hasItems()) {
				this.$('.screening-back-to-dashboard,.screening-dashboard-nav-extend').animateCSS('slideDown');
			}

			if (this.dashboardClients != null) {
				this.dashboardClients.remove();
				this.dashboardClients = null;
			}

			this.$('.screening-dashboard-body').animateCSS('fadeIn');
			this.loader = new PJQ.Loader(this.$('.screening-dashboard-body'));

			client.prequal.fetch({
				success: _.bind(function () {
					if (client.hasItems()) {
						this.$('.screening-dashboard-view-client').prop('disabled', true).animateCSS('slideDown');
						this.$('.btn-export-prequal').animateCSS('slideDown');

						client.prequal.on('change:percentComplete', function () {
							this.renderCriteriaButton(client);
						}, this);

						if (client.get('isPrequalActive')) {
							this.headerAlert = new PJQ.Alert(this.$('.screening-dashboard-header'), {
								type: 'warning',
								text: '<strong>' + client.get('clientName') + '</strong> requires your qualification statement to be 100% complete before viewing any requested criteria.',
								isPrepend: true,
								animation: {
									in: 'fadeIn',
									out: 'fadeOut'
								}
							});
						}
					}

					this.renderCriteriaButton(client);

					this.prequalEditor = new PJQ.views.prequal.PrequalEditor({
						el: this.$('.screening-dashboard-body'),
						model: client.prequal,
						clients: this.collection,
						preferences: client.preferences,
						navContainer: this.$('.screening-dashboard-nav-extend'),
						dashboard: this
					});
					this.loader.remove();
					this.loader = null;
				}, this),
				error: function (model, result) {
					new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
						model: model,
						result: result
					});
				}
			});
		}, this);
	},
	renderCriteriaButton: function (client) {
		let percentComplete = client.prequal.get('percentComplete');
		this.$('.screening-dashboard-view-client').prop('disabled', percentComplete != null && percentComplete < 100);
	},
	backToDashboard: function () {
		this.contextClient = null;

		this.renderNavClient();

		if (this.headerAlert) {
			this.headerAlert.destroy();
			this.headerAlert = null;
		}

		this.$('.screening-back-to-dashboard,.screening-dashboard-view-client,.screening-dashboard-nav-extend').animateCSS('slideUp');
		this.$('.screening-dashboard-body').animateCSS('fadeOut', function () {
			if (this.prequalEditor) {
				this.prequalEditor.remove();
				this.prequalEditor = null;
			}
			else if (this.screeningEditor) {
				this.screeningEditor.remove();
				this.screeningEditor = null;
			}
			this.renderClients();
		}, this);
	},
	networkUpgrade: function () {
		let redirectURL = 'http://network.panteratools.com/pantera-network/?';
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_PORTAL))
			redirectURL = 'http://demo.panteratools.com/verified-network-long-video-page/?';
		//todo: load directorysettings from api
		else if (directorySettings.IsNetworkContact && directorySettings.NetworkVerificationLevel == 1)
			redirectURL = 'http://demo.panteratools.com/verified-network-landing-pages-from-pn/?';
		window.open(redirectURL + this.model.contact.id.toString(), '_blank');
	},
	editProfile: function () {
		PJQ.app.router.navigate('profile', {
			trigger: true
		});
	},
	viewFaq: function () {
		let faqItems = this.options.baseFaqItems;
		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_CRM) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DODGE_WG))
			faqItems = _.union(faqItems, this.options.proqualFaqItems);
		new PJQ.views.BaseModal({
			header: "Frequently Asked Questions",
			isShowOkButton: false,
			isShowCancelButton: true,
			cancelButtonText: "Close",
			body: PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.faq, {
				faqItems: faqItems
			}).html(),
			okButtonText: "Ok"
		});
	},
});

PJQ.views.screenings.ScreeningDashboardClients = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Dashboard-Clients')
	},
	events: {
		'click .btn-screening-view-prequal': 'viewClientPrequal',
		'click .btn-screening-view-client': 'viewClientScreenings',
		'click .screening-view-client-attention': 'viewClientScreeningsAttention'
	},
	renderData: function(){
		return {
			collection: this.collection
		};
	},
	afterRender: function () {
		_.each(this.collection.models, function (model) {
			let $clientElement = this.getClientElement(model.cid),
				statusStats = model.getItemStatusStats(),
				statusLabels = [],
				statusCounts = [],
				statusColors = [];

			//Render prequal progress and attach events
			if (model.prequal != null) {
				let progressBar = new PJQ.progress.ProgressBar($clientElement.find('.prequal-progress'), {
					isShowPercentage: true,
					height: 30,
					progress: model.prequal.get('percentComplete')
				});
				model.prequal.on('change:percentComplete', function () {
					progressBar.updateProgress(model.prequal.get('percentComplete'));
				}, this)
			}

			//Render screening items attention link
			let attentionItemsCount = _.size(model.getAttentionItems()),
				$attentionContainer = $clientElement.find('.screening-view-client-attention-container');
			if (attentionItemsCount > 0) {
				let $element = $('<button>', {
					class: 'btn btn-link text-danger screening-view-client-attention font-weight-bold fs-14'
				});
				if (attentionItemsCount === 1) {
					$element.text(attentionItemsCount.toString() + ' item requires your attention!');
				}
				else {
					$element.text(attentionItemsCount.toString() + ' items require your attention!');
				}
				$attentionContainer.html($element);
			}
			else {
				$attentionContainer.empty();
			}

			//Render screening items chart
			_.each(statusStats, function (status) {
				statusLabels.push(status.name);
				statusCounts.push(status.count);
				statusColors.push(status.color);
			});
			if (model.get('isPaid')) {
				new PJQ.charts.Chart($clientElement.find('.screening-items-status-chart'), {
					type: 'doughnut',
					height: 300,
					width: 300,
					data: {
						labels: statusLabels,
						datasets: [
							{
								data: statusCounts,
								backgroundColor: statusColors
							}
						]
					},
					onClick: _.bind(function (clickedSegments) {
						let clickedStatuses = _.map(clickedSegments, function (segment) {
							return segment._model.label.toLowerCase();
						});
						if (_.size(clickedStatuses) > 0) {
							this.options.dashboard.renderClientScreenings(model, clickedStatuses);
						}
					}, this)
				});
			}
		}, this);
	},
	viewClientPrequal: function (e) {
		if (this.options.dashboard) {
			this.options.dashboard.renderClientPrequal(this.collection.get($(e.currentTarget).closest('.screening-client').data('cid')));
		}
	},
	viewClientScreenings: function (e) {
		this.options.dashboard.renderClientScreenings(this.collection.get($(e.currentTarget).closest('.screening-client').data('cid')));
	},
	viewClientScreeningsAttention: function (e) {
		this.options.dashboard.renderClientScreenings(this.collection.get($(e.currentTarget).closest('.screening-client').data('cid')), 'attention');
	},
	getClientElement: function (cid) {
		return this.$('.screening-client[data-cid="' + cid + '"]');
	}
});

PJQ.views.screenings.ScreeningClientEditor = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Client'),
		subTemplates: {
			category: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Category'),
			sampleDocuments: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Sample-Documents')
		},
		canManage: false,
		isAdmin: false
	},
	events: {
		'click .btn-view-packages': 'viewPackages',
		'keyup .screening-items-search': 'filterItems',
		'click .screening-items-clear-filters': 'clearFilters'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true,
			filterItemStatuses: this.model.getItemStatusStats()
		};
	},
	afterRender: function () {
		this.filterPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.screening-items-filter'),
			onChange: _.bind(this.filterItems, this),
			isMultiple: true,
			isGrouped: true,
			defaultValue: this.options.filter,
			noneSelectedText: 'No Filters'
		});

		this.renderNav();
		this.renderCategories();
		this.$('.screening-editor-client').animateCSS('fadeIn');

		let helpAlertText = 'Please click the "View Requested Criteria" box(s) below for EACH enrollment listed to complete the enrollment registration(s).<br>Once enrolled, requested documentation can be uploaded & submitted for compliance processing.<br>Updated documentation is requested for all Items with a status of "Waiting", "Incomplete", or "Expired".<br>Items listed as "Global" link across  enrollments, eliminating the need to upload the same document to each enrollment.';
		$('.screening-dashboard-header').empty();
		new PJQ.Alert($('.screening-dashboard-header'), {
			text: helpAlertText
		});
	},
	viewPackages: function(){
		new PJQ.views.screenings.ScreeningInvitePackagesModal({
			packages: this.model.get('packages')
		});
	},
	renderNav: function () {
		if (_.size(this.options.navContainer) > 0) {
			if (this.$nav != null) {
				this.$nav.remove();
				this.$nav = null;
			}

			this.$nav = $('<div>', {
				class: 'screening-nav-container hidden'
			});
			this.addElements(this.$nav);
			this.options.navContainer.prepend(this.$nav);

			if (_.size(this.model.sampleDocuments.models) > 0) {
				this.renderSubTemplate(true, this.options.subTemplates.sampleDocuments, this.$nav, {
					model: this.model
				});
				this.$nav.find('.screening-sample-documents-download-all').on('click', _.bind(this.downloadAllSampleDocuments, this));
				this.$nav.find('.screening-sample-document-download').on('click', _.bind(this.downloadSampleDocument, this));
				this.$nav.animateCSS('slideDown');
			}
		}
	},
	renderCategories: function () {
		let $categoriesContainer = this.$('.screening-editor-categories');
		this.categoryViews = [];
		_.each(this.model.categories.models, function (category) {
			//Bind any status change in any item to filterItems
			//This is because if the status changes, there may be a status filter and this item might need to be filtered out
			_.each(category.items.models, _.bind(function (item) {
				item.on('change:status', _.bind(this.filterItems, this));
			}, this));

			let $category = $('<div>', {
				class: 'screening-editor-category',
				'data-cid': category.cid
			});
			$categoriesContainer.append($category);
			let categoryView = new PJQ.views.screenings.ScreeningCategory({
				el: $category,
				model: category,
				client: this.model,
				canManage: this.options.canManage === true,
				isAdmin: this.options.isAdmin === true
			});
			this.categoryViews.push(categoryView);
		}, this);
	},
	filterItems: function () {
		let itemCids = _.map(this.getFilteredItems(), function (item) {
			return item.cid;
		});
		this.$('.screening-editor-item-toggle').each(function () {
			let $item = $(this);
			if (_.contains(itemCids, $item.data('cid'))) {
				$item.removeClass('hidden');
			}
			else {
				$item.addClass('hidden');
			}
		});

		this.$('.screening-editor-category').each(function () {
			if (_.size($(this).find('.nav-item.screening-editor-item-toggle:not(.hidden)')) > 0) {
				$(this).removeClass('hidden');

				//Ensure at least one of the tabs for this category that is shown is selected
				let showNav = $(this).find('.nav-item.screening-editor-item-toggle:not(.hidden)>.nav-link').first();
				if (_.size(showNav) > 0) {
					$(this).find('.nav-item.screening-editor-item-toggle.active').removeClass('active').removeClass('show');
					showNav.addClass('active show');
				}
			}
			else {
				$(this).addClass('hidden');
			}
		});

		_.each(this.categoryViews, function (categoryView) {
			categoryView.renderHeader();
		});
	},
	downloadAllSampleDocuments: function () {
		this.model.sampleDocuments.download();
	},
	downloadSampleDocument: function (e) {
		let sampleDocument = this.model.sampleDocuments.get($(e.currentTarget).data("cid"));
		sampleDocument.download();
	},
	getFilteredItems: function () {
		let searchFilter = this.getSearchFilter().toLowerCase(),
			filters = this.getStatusFilter(),
			items = this.model.categories.getItems();

		this.$('.screening-items-clear-filters').prop('disabled', _.size(searchFilter) === 0 && _.size(filters) === 0);

		if (_.size(searchFilter) > 0) {
			items = _.filter(items, function (item) {
				return item.get('name').toLowerCase().indexOf(searchFilter) !== -1;
			});
		}

		if (_.size(filters.general) > 0) {
			if (_.contains(filters.general, 'attention')) {
				items = _.filter(items, function (item) {
					return item.get('status').needsAttention;
				});
			}

			if (_.contains(filters.general, 'flagged')) {
				items = _.filter(items, function (item) {
					return item.get('isFlagged');
				});
			}
		}

		if (_.size(filters.statuses) > 0) {
			items = _.filter(items, function (item) {
				return _.contains(filters.statuses, item.get('status').name.toLowerCase());
			});
		}

		if (_.size(filters.categories) > 0) {
			let categoryItemIds = [];
			_.each(this.model.categories.models, function (category) {
				if (filters.categories.indexOf(category.get('name').toLowerCase()) !== -1) {
					_.each(category.items.models, function (item) {
						categoryItemIds.push(item.cid);
					});
				}
			});
			items = _.filter(items, function (item) {
				return _.contains(categoryItemIds, item.cid);
			})
		}

		return items;
	},
	getSearchFilter: function () {
		return this.$('.screening-items-search').val().trim();
	},
	getStatusFilter: function () {
		return this.filterPicker.getValue();
	},
	clearFilters: function () {
		this.filterPicker.deselectAll();
		this.$('.screening-items-search').val('');
		this.filterItems();
	}
});

PJQ.views.screenings.ScreeningCategory = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Category'),
		subTemplates: {
			header: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Category-Header')
		}
	},
	events: {
		'keyup .screening-items-search': 'filterItems',
		'click .screening-items-clear-filters': 'clearFilters'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		};
	},
	afterRender: function () {
		this.renderHeader();
		let $itemsContainer = this.$('.screening-category-items');
		_.each(this.model.items.models, function (item, index) {
			this.listenTo(item, 'change:status', _.bind(this.itemChanged, this));

			new PJQ.views.collapse.BaseCollapse({
				el: this.$el.closest('#screeningCategoryCollapse')
			});

			this.renderItemTabStatusBadge(item);

			let $item = $('<div>', {
				id: "screeningItemAccordionItem_" + item.cid,
				class: 'tab-pane fade screening-editor-item screening-editor-item-toggle' + (index === 0 ? ' show active' : ''),
				'data-cid': item.cid,
				role: 'tabpanel'
			});
			$itemsContainer.append($item);

			new PJQ.views.screenings.ScreeningItem({
				el: $item,
				model: item,
				categoryView: this,
				canManage: this.options.canManage === true,
				isAdmin: this.options.isAdmin === true
			});
		}, this);

		if (_.size(this.model.grades.models) > 0) {
			let grade = this.model.get('gradeId');
			let gradeSelector = new PJQ.inputs.Selectpicker({
				el: this.$('.select-grade'),
				isIntChoices: true,
				noneSelectedText: 'Needs Approval',
				defaultValue: grade,
				onChange: _.bind(function (newGrade) {
					gradeSelector.hideError();
					this.model.set('gradeId', newGrade > 0 ? newGrade : null);
					this.updateGrade();
				}, this)
			});

			if(!(grade > 0)){
				gradeSelector.showError();
			}
		}
	},
	updateGrade: function () {
		let contactId = this.options.client.get('contactId');
		if (!(contactId > 0)) {
			return;
		}
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: contactId
				},
				{
					endpoint: 'screenings',
				},
				{
					endpoint: 'categories',
					value: this.model.id
				}
			], [
				{
					parameter: 'grade',
					value: this.model.get('gradeId')
				},
				{
					parameter: 'flagged',
					value: this.model.get('isFlagged')
				}
			])
		}).put();
	},
	renderHeader: function () {
		this.renderSubTemplate(false, this.options.subTemplates.header, this.$('.category-header'), {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		});
	},
	itemChanged: function (changedItem) {
		this.renderHeader();
		this.renderItemTabStatusBadge(changedItem);
	},
	renderItemTabStatusBadge: function (item) {
		let badgeContainer = this.$('a[href="#screeningItemAccordionItem_' + item.cid + '"]').find('.screening-status-badge-container'),
			badge = $('<span>', {
				class: 'badge fs-13',
				style: 'background-color:' + item.get('status').textColor + ';color:' + item.get('status').backgroundColor
			}).text(item.get('status').name);
		badgeContainer.html(badge);
	}
});

PJQ.views.screenings.ScreeningItem = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item'),
		subTemplates: {
			header: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Header'),
			comment: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Comment'),
			question: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Question'),
			questionInput: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Question-Input'),
			footer: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Item-Footer'),
		}
	},
	events: {
		'change .screening-item-cant-provide': 'cantProvideChanged',
		'click .screening-item-in-process': 'updateItemInProcess',
		'click .screening-item-expired': 'updateItemExpired',
		'click .screening-item-incomplete': 'updateItemIncomplete',
		'click .screening-item-complete': 'updateItemComplete',
		'click .screening-item-done': 'submitItem',
		'keyup .screening-item-comment-input': 'commentChanged',
		'click .screening-item-comment-add': 'addComment'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			canEdit: this.model.get('status').canEdit,
			subTemplates: this.options.subTemplates,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		};
	},
	afterRender: function () {
		this.renderHeader();
		this.renderFooter();
		if (this.model.get('isFileUpload')) {
			this.renderFileUploader();
		}
		else if (_.size(this.model.questions.models) > 0) {
			this.renderQuestions();
		}
		this.renderComments();
	},
	renderQuestions: function () {
		let $questionContainer = this.$('.screening-item-questions');
		_.each(this.model.questions.models, function (question) {
			this.renderSubTemplate(true, this.options.subTemplates.question, $questionContainer, {
				model: question,
				canEdit: this.model.get('status').canEdit && this.model.get('status').screeningStatusId !== 7,
				subTemplates: this.options.subTemplates,
				canManage: this.options.canManage === true,
				isAdmin: this.options.isAdmin === true
			});
		}, this);

		let self = this;
		$questionContainer.find('.input-select,.input-bool').each(function () {
			let input = $(this);
			new PJQ.inputs.Selectpicker({
				el: input,
				onChange: function (value) {
					if (input.hasClass('input-bool'))
						value = value.toLowerCase() === 'true';

					let question = self.model.questions.get(input.data('cid'));
					self.questionValueChanged(question, value);
				}
			});

			new PJQ.Binder($questionContainer, null, {
				watchElements: [
					'input',
					'textarea'
				],
				onChange: function (changeEl, attribute, value) {
					let question = self.model.questions.get(changeEl.data('cid'));
					self.questionValueChanged(question, value);
				}
			});
		});
	},
	renderHeader: function () {
		let canManage = this.options.canManage === true,
			expires = this.model.get('expiresOn') == null ? null : new Date(this.model.get('expiresOn')),
			isExpired = PJQ.helpers.dateHelpers.checkDateIsBeforeToday(expires);
		this.renderSubTemplate(false, this.options.subTemplates.header, this.$('.screening-item-header'), {
			model: this.model,
			canManage: canManage,
			isAdmin: this.options.isAdmin === true
		}, _.bind(function () {
			if (canManage || expires != null) {
				new PJQ.inputs.DateEditorInput({
					el: this.$('.item-expiration'),
					canEdit: canManage,
					value: expires,
					dateFormat: PJQ.helpers.dateHelpers.dateFormats.DATE,
					label: expires != null && isExpired ? "Expired" : "Expires",
					onSave: _.bind(function (newValue) {
						this.model.updateExpiresOn(newValue, function () {
						});
					}, this)
				});
			}
		}, this));
	},
	renderFooter: function () {
		this.renderSubTemplate(false, this.options.subTemplates.footer, this.$('.screening-item-footer'), {
			model: this.model,
			canManage: this.options.canManage === true,
			isAdmin: this.options.isAdmin === true
		});
	},
	questionValueChanged: function (question, value) {
		question.set('responseValue', value);
		question.queueSave();
	},
	renderFileUploader: function () {
		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.screening-item-file-upload'),
			collection: this.model.attachments,
			allowedExtensions: this.model.get('allowedExtensions'),
			isRemoveOnComplete: true,
			canUpload: this.model.get('status').canEdit && this.model.get('status').screeningStatusId !== 3,
			canDelete: this.options.isAdmin,
			showCreatedByLink: false,
			autoProcessQueue: this.model.get('status').needsAttention,
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'screenings',
					value: this.model.get('masterUserId')
				},
				{
					endpoint: 'items',
					value: this.model.id
				},
				{
					endpoint: 'attachments'
				}
			]),
			onDrop: _.bind(function () {
				if (!this.model.get('status').needsAttention) {
					new PJQ.views.BaseModal({
						header: 'Confirm Upload',
						body: '<div class="text-dark fs-14">Are you sure you want to upload new attachments?  You will have to re-submit this item.</div>',
						okButtonText: 'Yes',
						onOk: _.bind(function () {
							this.model.moveWaiting(_.bind(function () {
								this.options.categoryView.itemChanged(this.model);
								this.renderHeader();
								if (this.model.get('isRequired') === false) {
									this.$('.screening-item-cant-provide-container').removeClass('hidden');
								}
								this.fileUploader.dropzone.options.autoProcessQueue = true;
								this.fileUploader.dropzone.processQueue();
							}, this));
						}, this),
						isShowCancelButton: true,
						cancelButtonText: "No"
					});
				}
			}, this)
		});
	},
	cantProvideChanged: function () {
		let reasonModal = new PJQ.views.screenings.ProvideReasonModal({
			onConfirm: _.bind(function () {
				let reason = reasonModal.$('.provide-reason-input').val();
				this.model.submitProcessing(_.bind(function () {
					new PJQ.models.screenings.ScreeningComment({
						masterUserId: this.model.get('masterUserId'),
						screeningInviteItemId: this.model.id,
						comment: reason
					}).save(null, {
						success: _.bind(function (model) {
							this.model.comments.add(model);
							if (this.options.categoryView != null) {
								this.options.categoryView.itemChanged(this.model);
							}
							this.render();
						}, this)
					});
				}, this));
			}, this),
			onCancel: _.bind(function () {
				this.$('.screening-item-cant-provide').prop('checked', false);
			}, this),
		});
	},
	renderComments: function () {
		if (this.model.comments != null && _.size(this.model.comments.models) > 0) {
			let comments = _.sortBy(this.model.comments.models, function (comment) {
				return new Date(comment.get('createdOn'))
			}).reverse();
			new PJQ.Pagination(this.$('.screening-item-comments'), {
				dataSource: comments,
				renderData: {
					canManage: this.options.canManage === true,
					isAdmin: this.options.isAdmin
				},
				pageSize: 5,
				pageItemTemplate: this.options.subTemplates.comment
			});
		}
		else {
			this.$('.screening-item-comments').append($('<div>', {class: 'fs-16 text-muted text-align-center font-weight-light'}).text('No comments yet'));
		}
	},
	commentChanged: function () {
		let comment = this.$('.screening-item-comment-input').val();
		this.$('.screening-item-comment-add').prop('disabled', _.size(comment) === 0);
	},
	addComment: function () {
		let commentText = this.$('.screening-item-comment-input').val(),
			isVisibleContact = !this.options.isAdmin || this.$('.cb-comment-visible-contact').prop('checked');
		new PJQ.views.BaseModal({
			header: 'Confirm Comment',
			body: '<div class="text-dark fs-14">Are you sure you want to add this comment?  You will not be able to edit or remove it later.</div><div class="alert alert-primary mt-2 pre-wrap">' + commentText + '</div>',
			okButtonText: 'Yes',
			onOk: _.bind(function () {
				new PJQ.models.screenings.ScreeningComment({
					masterUserId: this.model.get('masterUserId'),
					screeningInviteItemId: this.model.id,
					comment: commentText,
					isVisibleContact: isVisibleContact
				}).save(null, {
					success: _.bind(function (model) {
						this.model.comments.add(model);
						this.renderComments();
						this.resetCommentInput();
					}, this)
				});
			}, this),
			isShowCancelButton: true,
			cancelButtonText: "No"
		})
	},
	resetCommentInput: function () {
		this.$('.screening-item-comment-input').val('');
		this.$('.screening-item-comment-add').prop('disabled', true);
	},
	validate: function () {
		let isValid = true;
		if (this.model.get('isFileUpload')) {
			if (this.model.get('isRequired') && _.size(this.model.attachments.models) === 0) {
				isValid = false;
				this.fileUploadValidationError = this.fileUploader.showError('You must upload at least 1 file', null);
			}
		}
		else {
			_.each(this.model.questions.models, function (question) {
				let isFieldValid = true;
				if (question.get('isRequired')) {
					if (question.get('type').toLowerCase() === 'bool') {
						if (question.get('responseValue') !== false && question.get('responseValue') !== true) {
							isFieldValid = false;
						}
					}
					else if (_.size(question.get('responseValue')) === 0) {
						isFieldValid = false;
					}
				}

				PJQ.helpers.inputHelpers.setInputError(this.$('[data-cid="' + question.cid + '"]'), isFieldValid);

				isValid = isValid ? isFieldValid : isValid;
			}, this);
		}
		return isValid;
	},
	updateItemInProcess: function () {
		if (this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.IN_PROCESS, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	updateItemExpired: function () {
		if (this.options.canManage && this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.EXPIRED, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	updateItemIncomplete: function () {
		if (this.options.canManage && this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.INCOMPLETE, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	updateItemComplete: function () {
		if (this.options.canManage && this.options.isAdmin) {
			this.model.setStatus(PJQ.constants.screenings.statuses.COMPLETE, _.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	},
	submitItem: function () {
		if (this.validate()) {
			this.model.submitProcessing(_.bind(function () {
				if (this.options.categoryView != null) {
					this.options.categoryView.itemChanged(this.model);
				}
				this.render();
			}, this));
		}
	}
});

PJQ.views.screenings.ProvideReasonModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Modal-Screening-Editor-Provide-Reason'),
		onCancel: _.noop,
		onConfirm: _.noop
	},
	events: {
		'keyup .provide-reason-input': 'reasonChanged',
		'click .provide-reason-cancel': 'cancel',
		'click .provide-reason-confirm': 'confirm'
	},
	reasonChanged: function () {
		let reason = this.$('.provide-reason-input').val();
		this.$('.provide-reason-confirm').prop('disabled', _.size(reason) === 0);
	},
	cancel: function () {
		this.options.onCancel();
	},
	confirm: function () {
		this.options.onConfirm();
	}
});

PJQ.views.screenings.ScreeningTermsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Modal-Screening-Terms'),
		onComplete: _.noop,
		maxWidth: '800px'
	},
	events: {
		'click .terms-accept': 'accept'
	},
	afterRender: function () {
		this.$('.terms-text').height($(window).height() - 250);
		this.renderNextTerm();
	},
	renderNextTerm: function () {
		this.currentTerm = this.getNextTerm();
		if (this.currentTerm == null) {
			this.removeModal();
			if (typeof this.options.onComplete === 'function')
				this.options.onComplete();
		}
		else {
			this.$('.terms-title').html(this.currentTerm.get('title'));
			this.$('.terms-text').html(this.currentTerm.get('text'));
		}
	},
	getNextTerm: function () {
		return _.find(this.collection.models, function (term) {
			return term.get('isActive') && !term.get('isAccepted');
		});
	},
	accept: function () {
		this.currentTerm.save({
			isAccepted: true
		}, {
			success: _.bind(function () {
				this.renderNextTerm();
			}, this)
		});
	}
});

PJQ.views.screenings.ScreeningInvitePackagesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Modal-Screening-Invite-Packages'),
		onComplete: _.noop,
		maxWidth: 800
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.packages-table',
			data: this.options.packages,
			isHideSearch: true,
			rowId: 'cid',
			order: [1, 'asc'],
			language: {
				zeroRecords: 'No packages have been requested yet'
			},
			columns: [
				{
					"data": "name",
					"title": "Name",
					"width:": "40%"
				},
				{
					"data": "requestedOn",
					"title": "Requested",
					"render": function (data, type, row) {
						return data ? PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE) : '';
					}
				},
				{
					"data": "enrolledOn",
					"title": "Enrolled",
					"render": function (data, type, row) {
						return data ? PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE) : '';
					}
				},
				{
					"data": "expiresOn",
					"title": "Expires",
					"render": function (data, type, row) {
						return data ? PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE) : '';
					}
				}
			]
		});
	}
});
